import * as React from 'react';

const Jcb = (props: React.ComponentProps<'svg'>) => (
  <svg
    viewBox="0 0 58 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <rect x="0.5" y="0.5" width="57" height="39" rx="5.5" fill="white" />
    <rect x="0.5" y="0.5" width="57" height="39" rx="5.5" stroke="#E5E7EB" />
    <path
      d="M36.6364 19.9239C37.5219 19.9431 38.4123 19.8848 39.2942 19.9542C40.1873 20.1208 40.4026 21.4729 39.6091 21.9157C39.0677 22.2074 38.4246 22.0243 37.8377 22.0758H36.6364V19.9239V19.9239ZM39.8062 17.4882C40.0029 18.1826 39.3335 18.806 38.6648 18.7104H36.6364C36.6506 18.0556 36.6086 17.3449 36.657 16.7245C37.4696 16.7474 38.2896 16.6779 39.0975 16.7609C39.4446 16.8481 39.7351 17.1335 39.8062 17.4882V17.4882ZM44.6877 7.19097C44.7254 8.51703 44.6932 9.91319 44.704 11.2662C44.7015 16.7668 44.7093 22.2673 44.6997 27.7683C44.6641 29.8298 42.8371 31.6211 40.7898 31.6622C38.7406 31.6706 36.6911 31.6635 34.6416 31.6658V23.3499C36.8746 23.3384 39.1088 23.3734 41.3409 23.3325C42.3764 23.2675 43.5106 22.5843 43.5588 21.4448C43.6807 20.3003 42.6017 19.5087 41.5773 19.3837C41.1835 19.3735 41.1951 19.2689 41.5773 19.2233C42.5544 19.0121 43.3216 18.0009 43.0342 16.9881C42.7892 15.923 41.6119 15.5107 40.6326 15.5127C38.6359 15.4992 36.6388 15.5108 34.642 15.5069C34.6549 13.9544 34.6151 12.4003 34.6635 10.849C34.8217 8.82466 36.6947 7.15528 38.7131 7.1915C40.7049 7.19119 42.6964 7.19119 44.6877 7.19112V7.19097Z"
      fill="url(#jcb_a)"
    />
    <path
      d="M12.0775 11.0585C12.1285 9.00026 13.9633 7.22366 16.0079 7.19358C18.0495 7.18729 20.0915 7.19267 22.1331 7.19086C22.1275 14.0773 22.1442 20.9645 22.1247 27.8505C22.0461 29.8838 20.2313 31.6265 18.209 31.6625C16.1634 31.6699 14.1177 31.6636 12.0721 31.6656V23.0694C14.0591 23.5388 16.1427 23.7386 18.1697 23.4273C19.3814 23.2323 20.707 22.6373 21.1173 21.3802C21.4191 20.305 21.2492 19.1733 21.2941 18.0697V15.5068H17.7861C17.7704 17.2019 17.8184 18.8999 17.7608 20.5929C17.6662 21.6335 16.6356 22.2947 15.6542 22.2594C14.437 22.2723 12.025 21.3773 12.025 21.3773C12.0189 18.2014 12.0603 14.2241 12.0775 11.0588V11.0585Z"
      fill="url(#jcb_b)"
    />
    <path
      d="M23.4414 16.5407C23.2567 16.5799 23.4042 15.9117 23.357 15.6583C23.3696 14.0557 23.3307 12.4514 23.3785 10.85C23.5362 8.81714 25.4236 7.14359 27.4502 7.19118H33.4185C33.4129 14.0776 33.4295 20.9648 33.4101 27.8509C33.3314 29.8841 31.5164 31.6268 29.494 31.6628C27.4485 31.6706 25.4027 31.664 23.3569 31.666V22.2477C24.7541 23.394 26.653 23.5725 28.3936 23.5756C29.7057 23.5751 31.0103 23.3728 32.2846 23.0702V21.3447C30.8485 22.0605 29.1603 22.5151 27.5684 22.1039C26.4579 21.8275 25.6518 20.7542 25.6698 19.6082C25.5411 18.4164 26.2397 17.1582 27.4109 16.8039C28.865 16.3486 30.4498 16.6968 31.8128 17.2886C32.1049 17.4415 32.4013 17.6312 32.2845 17.1431V15.7869C30.0049 15.2445 27.5789 15.0449 25.2886 15.6349C24.6257 15.8219 23.9799 16.1055 23.4414 16.5408V16.5407Z"
      fill="url(#jcb_c)"
    />
    <defs>
      <linearGradient
        id="jcb_a"
        x1="34.5729"
        y1="18.9051"
        x2="44.6405"
        y2="18.9051"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#58B03A" />
        <stop offset="1" stopColor="#55B330" />
      </linearGradient>
      <linearGradient
        id="jcb_b"
        x1="11.8581"
        y1="19.6626"
        x2="21.9682"
        y2="19.6626"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0F6EB6" />
        <stop offset="1" stopColor="#006DBA" />
      </linearGradient>
      <linearGradient
        id="jcb_c"
        x1="23.3422"
        y1="19.1424"
        x2="33.4166"
        y2="19.1424"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DE0D3D" />
        <stop offset="1" stopColor="#E30138" />
      </linearGradient>
    </defs>
  </svg>
);

export default Jcb;
